{
  "API Log": "API Log",
  "Menu": "Menu",
  "admin": {
    "Database": "Database",
    "Laravel Log Dosyası": "Laravel Log File",
    "Toplam": "Total",
    "laravel log": "Laravel Log",
    "Silme başarısız.": "Delete failed.",
    "Banka": "Bank",
    "Bankaları güncelle": "Update banks",
    "Tatil": "Holiday",
    "Tatilleri güncelle": "Update holidays",
    "İl/İlçe": "City/District",
    "İl ve ilçeleri güncelle": "Update cities and districts"
  }
}
